// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1EOpZ","right":"styles_right__3NTYx"};